import React, { useEffect } from "react";
import HomePageBanner from "../Components/Home/HomePageBanner";
import HomePageJoinUs from "../Components/Home/HomePageJoinUs";
import HomePageFeatures from "../Components/Home/HomePageFeatures";
import HomePagePractice from "../Components/Home/HomePagePractice";
import HomePageTeam from "../Components/Home/HomePageTeam";
import HomePageLearn from "../Components/Home/HomePageLearn";
import HomePageBlog from "../Components/Home/HomePageBlog";
import HomePageSubscribe from "../Components/Home/HomePageSubscribe";
import NavBar from "../Components/NavBar";
import Footer from "../Components/Footer";
const HomePageProjectTwo = () => {
  useEffect(()=>{
    window.scrollTo({
      top: 0,
     
      behavior: 'smooth'
    });
  })
  return (
    <>
      <NavBar />
      <HomePageBanner />
      <HomePageJoinUs />
      <HomePageFeatures />
      <HomePagePractice />
      <HomePageTeam />
      <HomePageLearn />
      <HomePageBlog />
      <HomePageSubscribe />
      <Footer />
    </>
  );
};

export default HomePageProjectTwo;
